export const billingTransactionType = {
  BILL: 'BILL',
  CREDITMEMO: 'CREDITMEMO',
  PAYMENT: 'PAYMENT'
};
